//action types

// List, Data, Create, Update, Delete, Search

export const APPOINTMENT_LIST_REQUEST = "APPOINTMENT_LIST_REQUEST";
export const APPOINTMENT_LIST_SUCCESS = "APPOINTMENT_LIST_SUCCESS";
export const APPOINTMENT_LIST_FAIL = "APPOINTMENT_LIST_FAIL";

export const APPOINTMENT_DATA_REQUEST = "APPOINTMENT_DATA_REQUEST";
export const APPOINTMENT_DATA_SUCCESS = "APPOINTMENT_DATA_SUCCESS";
export const APPOINTMENT_DATA_FAIL = "APPOINTMENT_DATA_FAIL";

export const APPOINTMENT_CREATE_REQUEST = "APPOINTMENT_CREATE_REQUEST";
export const APPOINTMENT_CREATE_SUCCESS = "APPOINTMENT_CREATE_SUCCESS";
export const APPOINTMENT_CREATE_FAIL = "APPOINTMENT_CREATE_FAIL";

export const APPOINTMENT_UPDATE_REQUEST = "APPOINTMENT_UPDATE_REQUEST";
export const APPOINTMENT_UPDATE_SUCCESS = "APPOINTMENT_UPDATE_SUCCESS";
export const APPOINTMENT_UPDATE_FAIL = "APPOINTMENT_UPDATE_FAIL";

export const APPOINTMENT_DELETE_REQUEST = "APPOINTMENT_DELETE_REQUEST";
export const APPOINTMENT_DELETE_SUCCESS = "APPOINTMENT_DELETE_SUCCESS";
export const APPOINTMENT_DELETE_FAIL = "APPOINTMENT_DELETE_FAIL";

export const APPOINTMENT_SEARCH_REQUEST = "APPOINTMENT_SEARCH_REQUEST";
export const APPOINTMENT_SEARCH_SUCCESS = "APPOINTMENT_SEARCH_SUCCESS";
export const APPOINTMENT_SEARCH_FAIL = "APPOINTMENT_SEARCH_FAIL";

//Appointment Status list , data, create, update, delete

export const APPOINTMENT_STATUS_LIST_REQUEST =
  "APPOINTMENT_STATUS_LIST_REQUEST";
export const APPOINTMENT_STATUS_LIST_SUCCESS =
  "APPOINTMENT_STATUS_LIST_SUCCESS";
export const APPOINTMENT_STATUS_LIST_FAIL = "APPOINTMENT_STATUS_LIST_FAIL";

export const APPOINTMENT_STATUS_DATA_REQUEST =
  "APPOINTMENT_STATUS_DATA_REQUEST";
export const APPOINTMENT_STATUS_DATA_SUCCESS =
  "APPOINTMENT_STATUS_DATA_SUCCESS";
export const APPOINTMENT_STATUS_DATA_FAIL = "APPOINTMENT_STATUS_DATA_FAIL";

export const APPOINTMENT_STATUS_CREATE_REQUEST =
  "APPOINTMENT_STATUS_CREATE_REQUEST";
export const APPOINTMENT_STATUS_CREATE_SUCCESS =
  "APPOINTMENT_STATUS_CREATE_SUCCESS";
export const APPOINTMENT_STATUS_CREATE_FAIL = "APPOINTMENT_STATUS_CREATE_FAIL";

export const APPOINTMENT_STATUS_UPDATE_REQUEST =
  "APPOINTMENT_STATUS_UPDATE_REQUEST";
export const APPOINTMENT_STATUS_UPDATE_SUCCESS =
  "APPOINTMENT_STATUS_UPDATE_SUCCESS";
export const APPOINTMENT_STATUS_UPDATE_FAIL = "APPOINTMENT_STATUS_UPDATE_FAIL";

export const APPOINTMENT_STATUS_DELETE_REQUEST =
  "APPOINTMENT_STATUS_DELETE_REQUEST";
export const APPOINTMENT_STATUS_DELETE_SUCCESS =
  "APPOINTMENT_STATUS_DELETE_SUCCESS";
export const APPOINTMENT_STATUS_DELETE_FAIL = "APPOINTMENT_STATUS_DELETE_FAIL";

//Appointment Type list , data, create, update, delete

export const APPOINTMENT_TYPE_LIST_REQUEST = "APPOINTMENT_TYPE_LIST_REQUEST";
export const APPOINTMENT_TYPE_LIST_SUCCESS = "APPOINTMENT_TYPE_LIST_SUCCESS";
export const APPOINTMENT_TYPE_LIST_FAIL = "APPOINTMENT_TYPE_LIST_FAIL";

export const APPOINTMENT_TYPE_DATA_REQUEST = "APPOINTMENT_TYPE_DATA_REQUEST";
export const APPOINTMENT_TYPE_DATA_SUCCESS = "APPOINTMENT_TYPE_DATA_SUCCESS";
export const APPOINTMENT_TYPE_DATA_FAIL = "APPOINTMENT_TYPE_DATA_FAIL";

export const APPOINTMENT_TYPE_CREATE_REQUEST =
  "APPOINTMENT_TYPE_CREATE_REQUEST";
export const APPOINTMENT_TYPE_CREATE_SUCCESS =
  "APPOINTMENT_TYPE_CREATE_SUCCESS";
export const APPOINTMENT_TYPE_CREATE_FAIL = "APPOINTMENT_TYPE_CREATE_FAIL";

export const APPOINTMENT_TYPE_UPDATE_REQUEST =
  "APPOINTMENT_TYPE_UPDATE_REQUEST";
export const APPOINTMENT_TYPE_UPDATE_SUCCESS =
  "APPOINTMENT_TYPE_UPDATE_SUCCESS";
export const APPOINTMENT_TYPE_UPDATE_FAIL = "APPOINTMENT_TYPE_UPDATE_FAIL";

export const APPOINTMENT_TYPE_DELETE_REQUEST =
  "APPOINTMENT_TYPE_DELETE_REQUEST";
export const APPOINTMENT_TYPE_DELETE_SUCCESS =
  "APPOINTMENT_TYPE_DELETE_SUCCESS";
export const APPOINTMENT_TYPE_DELETE_FAIL = "APPOINTMENT_TYPE_DELETE_FAIL";

// search for appointment specific list

export const APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST =
  "APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST";
export const APPOINTMENT_SEARCH_SPECIFIC_LIST_SUCCESS =
  "APPOINTMENT_SEARCH_SPECIFIC_LIST_SUCCESS";
export const APPOINTMENT_SEARCH_SPECIFIC_LIST_FAIL =
  "APPOINTMENT_SEARCH_SPECIFIC_LIST_FAIL";
